import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-tooltip',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {

  showHoverTooltip = false;
  showClickTooltip = false;

  @Input() text: string;

  get hasText() {
    return this.text && this.text.length > 0 && !this.text.startsWith("#");
  }

}
